import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  // Col,
  Drawer,
  //  Row
} from 'antd'
import logoImage from '../../assets/images/new_logo.png'

// import menu_star from '../../assets/images/menu-star.svg'
// import menu_star_on from '../../assets/images/menu-star-on.svg'
import useStore from '@/hooks/useStore'
import {
  IGetHeaderData, IGetLoginUser, IGetSubHeaderData,
  IUpdateMenuLike,
} from '@/service/rightNavCtrl'
import './index.less'

const drawerArr = {
  title: '즐겨 찾는 서비스',
  renderText: [
    { like: true, menuName: '유휴시설정보' },
    { like: true, menuName: '창업지원사업' },
  ],
}
function Header() {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const uiStore = useStore('uiStore')
  const facilityStore = useStore('facilityStore')
  const navigate = useNavigate()

  const [myPage, setMyPage] = useState('로그인')
  const [page404, setPage404] = useState('회원가입')
  const [menuData, setMenuData] = useState<any>([])
  const [subMenuData, setSubMenuData] = useState<any>({})
  const [openDrawer, setOpenDrawer] = useState(false)

  useEffect(() => {
    const id = localStorage.getItem('JSESSIONID') || ''
    const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id

    const obj = {
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IGetLoginUser(obj).then((res: any) => {
      if (res.code === 200) {
        if (res.result === null) {
          if (id2) {
            setMyPage('로그인')
            setPage404('회원가입')
          }
        }
        if (res.result && res.result.userId) {
          if (id2) {
            setMyPage('마이페이지')
            setPage404('로그아웃')
          }
        }
      }
    })
    init(id2)
    // window.addEventListener('hashchange', () => hashChangeCallback())
    // return () => window.removeEventListener('hashchange', () => hashChangeCallback())
  }, [])

  const init = async (id: any) => {
    const obj = {
      sysSeCode: '1',
      sessionId: id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    try {
      const res: any = await IGetHeaderData(obj)
      const { result = [] } = res
      const obj2 = JSON.parse(JSON.stringify(obj))
      delete obj2.sysSeCode
      const res2: any = await IGetSubHeaderData(obj2)
      if (res.code === 200) {
        setMenuData(result)
      }
      else {
        setMenuData([])
      }

      if (res2.code === 200) {
        const { result = [] } = res2
        const firstSubData = findSubData(res.result[0].menuId, result)
        const twoSubData = findSubData(res.result[1].menuId, result)
        const threeSubData = findSubData(res.result[2].menuId, result)
        const fourSubData = findSubData(res.result[3].menuId, result)
        const fiveSubData = findSubData(res.result[4].menuId, result)
        setSubMenuData({
          firstSubData,
          twoSubData,
          threeSubData,
          fourSubData,
          fiveSubData,
        })
      }
      else {
        setSubMenuData({})
      }
    }
    catch (error) {}
  }

  const findSubData = (id: string, data: any) => {
    const res = data.filter((item: any) => item.upperMenuId === id)
    return res
  }

  const handleRuralClick = (item: any) => {
    if (isDev) {
      console.log('item', item)

      if (item.menuId === '241') {
        uiStore.showRuralBusiness(true)
        facilityStore.showFacilityInfo(false)
      }
      else if (item.menuId === '240') {
        uiStore.showRuralBusiness(false)
      }
    }
    else {
      const href = window.location.origin
      const url = href + item.conPath + item.progrmUrl
      window.open(url, '_self')
    }
  }

  const handleFacilityClick = () => {
    uiStore.setSearchPartShow()
    uiStore.showRuralBusiness(false)
    navigate('/')
  }

  const jumpToMyPage = () => {
    // window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/myPage/main.do`
    window.location.href = '/ndpf/portal/myPage/main.do'
  }

  const jumpToMainPage = () => {
    // window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/main.do`
    window.location.href = '/ndpf/portal/main.do'
  }

  const jumpToLogin = () => {
    // window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/login/getLoginView.do`
    window.location.href = '/ndpf/portal/login/getLoginView.do'
  }

  const jumpToLogout = () => {
    // window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/login/getLogout.do`
    window.location.href = '/ndpf/portal/login/getLogout.do'
  }

  const jumpToSignup = () => {
    // window.location.href = `${window.SystemConfig.atbkWasServer}/ndpf/portal/join/getStplatView.do`
    window.location.href = '/ndpf/portal/join/getStplatView.do'
  }

  const renderSubMenu = (data: any) => {
    return (
      <>
        {data.map((item: any, index: number) => {
          return (
            <li key={index} className={'list-item'}>
              <a onClick={() => handleRuralClick(item)}>{item.menuNm}</a>
            </li>
          )
        })}
      </>
    )
  }
  const onOpenDrawer = () => {
    setOpenDrawer(true)
  }

  const onClose = () => {
    setOpenDrawer(false)
  }

  const handleLikeData = () => {
    if (menuData.length === 0 || Object.keys(subMenuData).length === 0)
      return
    const newArr: any = []
    const renderText = []
    const arr = menuData.filter((item: any) => item.like)
    const { firstSubData, twoSubData, threeSubData, fourSubData, fiveSubData } = subMenuData
    const arr2 = firstSubData.filter((item: any) => item.like)
    const arr3 = twoSubData.filter((item: any) => item.like)
    const arr4 = threeSubData.filter((item: any) => item.like)
    const arr5 = fourSubData.filter((item: any) => item.like)
    const arr6 = fiveSubData.filter((item: any) => item.like)
    renderText.push(...arr)
    renderText.push(...arr2)
    renderText.push(...arr3)
    renderText.push(...arr4)
    renderText.push(...arr5)
    renderText.push(...arr6)
    const obj = {
      title: '즐겨 찾는 서비스',
      renderText,
    }
    newArr.push(obj)
    return renderDrawerContent(newArr)
  }

  const handleAllData = () => {
    if (menuData.length === 0 || Object.keys(subMenuData).length === 0)
      return
    const newArr = []
    for (let i = 0; i < menuData.length; i++) {
      const { firstSubData, twoSubData, threeSubData, fourSubData, fiveSubData } = subMenuData
      const obj: any = {
        title: menuData[i].menuNm,
      }
      if (i === 0) {
        obj.renderText = firstSubData
      }
      if (i === 1) {
        obj.renderText = twoSubData
      }
      if (i === 2) {
        obj.renderText = threeSubData
      }
      if (i === 3) {
        obj.renderText = fourSubData
      }
      if (i === 4) {
        obj.renderText = fiveSubData
      }
      newArr.push(obj)
    }
    return renderDrawerContent(newArr)
  }

  const renderDrawerContent = (data: any) => {
    if (data.length === 0)
      return

    const onLike = (item: any) => {
      const id = localStorage.getItem('JSESSIONID') || ''
      const obj = {
        menuId: item.menuId,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        apiKey: window.SystemConfig.facilityApiKey,
      }
      IUpdateMenuLike(obj).then((res: any) => {
        const { code = 0 } = res
        if (code === 200) {
          const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id
          init(id2)
        }
      })
    }

    const onJump = (item: any) => {
      const href = window.location.origin
      const url = href + item.conPath + item.progrmUrl
      window.open(url, '_self')
    }

    return (
      <div className={'all'}>
          {data.map((item: any, index: number) => {
            return (
              <div className={'item-row'} key={index}>
                <strong className={'title'}>{item.title}</strong>
                <div className={'item2BoxAll'}>
                {item.renderText.map((item2: any, index2: number) => {
                  return (
                  <div className={'item2Box'}>
                      <div style={{ border: item2.like ? '1px solid #0a18c9' : '1px solid #ddd' }} key={index2} className={'item2'}>
                        <button className={`${item2.like ? 'like-active' : 'like'}`} onClick={() => { onLike(item2) }}
                        // style={{ background: item2.like ? menu_star_on : menu_star }}
                        ></button>
                        <span onClick={() => { onJump(item2) }}>{item2.menuNm}</span>
                      </div>
                  </div>
                  )
                })}
                </div>
              </div>
            )
          })}
      </div>
    )
  }
  return (
    <div className={'NongDi-Header'} style={{ background: '#fff', width: '100%' }}>
      <div className={'Header'}>
        <div className={'head-inner'}>
          <div className={'head-left'}>
            <h1 className={'logo'}>
              <a>
                <img src={logoImage} alt={'NongDi'} onClick={jumpToMainPage} />
              </a>
            </h1>
            <div className={'gnb'}>
              <ul className={'gnb-list'}>
                <li className={'gnb-item'}>
                  {menuData.length > 0 && (
                  // <a onClick={handleFacilityClick} className={'first-depth'}>
                       <a className={'first-depth'}>
                      {menuData[0].menuNm}
                    </a>
                  )}
                  {/* {!uiStore.SearchPartShow
                    ? ( */}
                  <ul className={'sub-list'}>{subMenuData.firstSubData && subMenuData.firstSubData.length > 0 && renderSubMenu(subMenuData.firstSubData)}</ul>
                  {/* )
                    : null} */}
                </li>
                <li className={'gnb-item'}>
                  {menuData.length > 1 && <a className={'first-depth'} translate="no">{menuData[1].menuNm}</a>}
                  <ul className={'sub-list'}>{subMenuData.twoSubData && subMenuData.twoSubData.length > 0 && renderSubMenu(subMenuData.twoSubData)}</ul>
                </li>
                <li className={'gnb-item'}>
                  {menuData.length > 2 && <a className={'first-depth'} translate="no">{menuData[2].menuNm}</a>}
                  <ul className={'sub-list'}>{subMenuData.threeSubData && subMenuData.threeSubData.length > 0 && renderSubMenu(subMenuData.threeSubData)}</ul>
                </li>
                <li className={'gnb-item'}>
                  {menuData.length > 3 && <a className={'first-depth'} translate="no">{menuData[3].menuNm}</a>}
                  <ul className={'sub-list'}>{subMenuData.fourSubData && subMenuData.fourSubData.length > 0 && renderSubMenu(subMenuData.fourSubData)}</ul>
                </li>
                <li className={'gnb-item'}>
                  {menuData.length > 4 && <a className={'first-depth'} translate="no">{menuData[4].menuNm}</a>}
                  <ul className={'sub-list'}>{subMenuData.fiveSubData && subMenuData.fiveSubData.length > 0 && renderSubMenu(subMenuData.fiveSubData)}</ul>
                </li>
              </ul>
              {/* <button className={'btn-all'} type={'button'}>
                메뉴전체보기
              </button> */}
            </div>
            <div className={'drawerText'}>
              {/* <li className={'gnb-item'}> */}
              <a className={`${openDrawer ? 'text-active' : ''} text`} onClick={onOpenDrawer}>
                메뉴전체보기
              </a>
              {/* </li> */}
            </div>
          </div>
          <div className={'login-inner'}>
            {myPage === '마이페이지'
              ? (
              <a onClick={jumpToMyPage} className={'main-log'}>
                {myPage}
              </a>
                )
              : (
              <a onClick={jumpToLogin} className={'main-log'}>
                {myPage}
              </a>
                )}

            <div className={'member-log'}>
              {page404 === '로그아웃'
                ? (
                <a onClick={jumpToLogout} className={'main-log'}>
                  {page404}
                </a>
                  )
                : (
                <a onClick={jumpToSignup} className={'main-log'}>
                  {page404}
                </a>
                  )}
              {/* <Link to="/404" className={'member-log'}>
              {page404}
            </Link> */}
            </div>
            <a className={`${openDrawer ? 'text-active' : ''} btn-all`} onClick={onOpenDrawer}>
              </a>
          </div>
          <Drawer size="large" closable={false} onClose={onClose} open={openDrawer}>
            <div className={'drawer-box'}>
              <button onClick={() => setOpenDrawer(false)} className={'btn-close'}></button>
              {
                menuData.length > 0 && Object.keys(subMenuData).length > 0
                && handleLikeData()
              }
              {
                menuData.length > 0 && Object.keys(subMenuData).length > 0
                && handleAllData()
              }
            </div>
          </Drawer>
        </div>
      </div>
    </div>
  )
}

export default observer(Header)
